module.exports = __webpack_public_path__ + "img/solid.0e7ac6c1.svg";